import { useSite } from "../contexts/SiteContext";
import { useAuth } from "../contexts/AuthContext";
import { Wrench } from "lucide-react";
import { Link } from "react-router-dom";

export default function MaintenanceOverlay() {
  const { settings } = useSite();
  const { user } = useAuth();
  if (!settings.maintenance_mode) return null;
  if (user?.role === "developer") return null;
  return (
    <div data-testid="maintenance-overlay" className="fixed inset-0 z-[60] maintenance-blur flex items-center justify-center p-6">
      <div className="max-w-lg w-full bg-white border-2 border-copper p-12 text-center shadow-2xl">
        <Wrench size={36} className="mx-auto text-copper mb-5"/>
        <div className="overline mb-3">System Notice</div>
        <h2 className="font-display text-4xl text-dark">Under Maintenance</h2>
        <p className="text-gray-600 mt-4 leading-relaxed">{settings.maintenance_message}</p>
        <Link to="/staff/login" className="inline-block mt-8 text-xs uppercase tracking-luxe text-copper hover:text-[#A0834F]">Staff sign in →</Link>
      </div>
    </div>
  );
}
